var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9c2aefcdc1f132bca5e7509b819f78f84384db3a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["perfect-gift-consumer@wolfe-llc"]={id:"9c2aefcdc1f132bca5e7509b819f78f84384db3a"};
      